module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('h3', {
    staticStyle: {
      "color": "rgb(102, 102, 102)",
      "text-align": "center",
      "margin-top": "2em"
    }
  }, [_vm._v("\r\n        " + _vm._s(_vm.title) + "\r\n        "), _vm._v(" "), _c('el-tag', {
    attrs: {
      "type": "success",
      "size": "medium "
    }
  }, [_vm._v("报名")])], 1), _vm._v(" "), _c('h4', {
    staticStyle: {
      "color": "rgb(102, 102, 102)",
      "text-align": "center",
      "margin-top": "2em"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "width:100%; height:100%;",
      "type": "warning"
    }
  }, [_vm._v("下载规程与资料")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "size": "width:100%; height:100%;",
      "type": "primary"
    },
    on: {
      "click": _vm.ExportReport
    }
  }, [_vm._v("下载报名表")])], 1)])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticClass: "bj",
    attrs: {
      "span": 4
    }
  }, [_c('el-table', {
    attrs: {
      "data": _vm.ServiceList,
      "max-height": "440"
    }
  }, [_c('el-table-column', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "赛事报名",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
              _vm.columnClick(scope)
            }
          }
        }, [_vm._v("\r\n                     " + _vm._s(scope.row.Name) + "\r\n                   ")])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "xinxitj"
  }), _vm._v(" "), _c('el-table', {
    attrs: {
      "max-height": "440"
    }
  }, [_c('el-table-column', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "label": "赛事服务",
      "align": "center"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          staticClass: "item",
          attrs: {
            "effect": "dark",
            "content": "",
            "placement": "left"
          }
        }, [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          nativeOn: {
            "click": function($event) {
              $event.preventDefault();
            }
          }
        }, [_vm._v("\r\n                      tttt\r\n                   ")])], 1)]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "margin-left": "0px"
    },
    attrs: {
      "span": 20
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.togglePlayer),
      expression: "togglePlayer"
    }]
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "width:100%; height:100%;",
      "type": "danger",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.playerAdd
    }
  }, [_vm._v("新报运动员")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "width:100%; height:100%;",
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getPlayerList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "运动员名称"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getPlayerList($event)
      }
    },
    model: {
      value: (_vm.filters.Name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "Name", $$v)
      },
      expression: "filters.Name"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.Loading),
      expression: "Loading"
    }],
    attrs: {
      "data": _vm.PlayerList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "证照",
      "width": "120",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-tooltip', {
          attrs: {
            "content": "点击查看大图",
            "placement": "right",
            "effect": "light"
          }
        }, [(scope.row.ImageUrl != null) ? _c('img', {
          staticStyle: {
            "height": "100px",
            "width": "100px",
            "background-image": "background-repeat: no-repeat",
            "background-position": "center center",
            "background-size": "cover"
          },
          attrs: {
            "src": scope.row.ImageUrl
          },
          on: {
            "click": function($event) {
              _vm.see(scope.row.ImageUrl)
            }
          }
        }) : _vm._e()])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "姓名",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "FullNname",
      "label": "拼音全称",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IDNumber",
      "label": "证件号码",
      "width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Birthday",
      "label": "生日",
      "width": "120",
      "formatter": _vm.formatDate,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Unit",
      "label": "分计单位",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Coache",
      "label": "教练",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CompetitionGroupName",
      "label": "赛事组名",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CompetitionGroupItemName",
      "label": "比赛项目",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CompetitionPostureName",
      "label": "泳姿名称",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Distance",
      "label": "距离",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Achievement",
      "label": "成绩",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Test",
      "label": "测验",
      "width": "120",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.Test == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "small"
          }
        }, [_vm._v("是")]) : _vm._e(), _vm._v(" "), (scope.row.Test == 0) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "small"
          }
        }, [_vm._v("否")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SpecialMark",
      "label": "特标",
      "width": "120",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.SpecialMark == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "small"
          }
        }, [_vm._v("是")]) : _vm._e(), _vm._v(" "), (scope.row.SpecialMark == 0) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "small"
          }
        }, [_vm._v("否")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CreationTime",
      "label": "报名时间",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "备注",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-tag', [_vm._v("当前共" + _vm._s(_vm.PlayerCount) + "条记录")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.PlayerCount
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggleStaff),
      expression: "toggleStaff"
    }]
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "width:100%; height:100%;",
      "type": "danger",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.staffAdd
    }
  }, [_vm._v("新报工作人员")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "width:100%; height:100%;",
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getStaffList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "工作人员名称"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getStaffList($event)
      }
    },
    model: {
      value: (_vm.filters.StaffName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "StaffName", $$v)
      },
      expression: "filters.StaffName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.Loading),
      expression: "Loading"
    }],
    attrs: {
      "data": _vm.StaffList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "姓名",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IDNumber",
      "label": "证件号码",
      "width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Birthday",
      "label": "生日",
      "width": "120",
      "formatter": _vm.formatDate,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IdentityName",
      "label": "身份",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "PartTimer",
      "label": "是否兼任",
      "width": "120",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [(scope.row.PartTimer == 1) ? _c('el-tag', {
          attrs: {
            "type": "success",
            "size": "small"
          }
        }, [_vm._v("是")]) : _vm._e(), _vm._v(" "), (scope.row.PartTimer == 0) ? _c('el-tag', {
          attrs: {
            "type": "danger",
            "size": "small"
          }
        }, [_vm._v("否")]) : _vm._e()]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CreationTime",
      "label": "报名时间",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "备注",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-tag', [_vm._v("当前共" + _vm._s(_vm.StaffCount) + "条记录")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.StaffCount
    },
    on: {
      "current-change": _vm.handleCurrentStaffChange
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toggleRelay),
      expression: "toggleRelay"
    }]
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "width:100%; height:100%;",
      "type": "danger",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.relayAdd
    }
  }, [_vm._v("新报接力")])], 1), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "width:100%; height:100%;",
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getList
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "接力赛名称"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getList($event)
      }
    },
    model: {
      value: (_vm.filters.GroupName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "GroupName", $$v)
      },
      expression: "filters.GroupName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.Loading),
      expression: "Loading"
    }],
    attrs: {
      "data": _vm.List,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "CompetitionGroupName",
      "label": "组名",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CompetitionGroupItemName",
      "label": "比赛项目",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "CreationTime",
      "label": "报名时间",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "备注",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "200",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-tag', [_vm._v("当前共" + _vm._s(_vm.Count) + "条记录")]), _vm._v(" "), _c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 10,
      "total": _vm.Count
    },
    on: {
      "current-change": _vm.handleCurrentChange1
    }
  })], 1)], 1)])], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "接力赛报名",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.RelayVisible),
      callback: function($$v) {
        _vm.RelayVisible = $$v
      },
      expression: "RelayVisible"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.RelayEntry),
      expression: "RelayEntry"
    }]
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "选择赛事分组"
    },
    on: {
      "change": _vm.relaySelectChange
    },
    model: {
      value: (_vm.filters.GroupId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "GroupId", $$v)
      },
      expression: "filters.GroupId"
    }
  }, _vm._l((_vm.GroupOptions), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.Loading),
      expression: "Loading"
    }],
    staticStyle: {
      "width": "1702px"
    },
    attrs: {
      "data": _vm.GroupItemTable,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "Prop": "Select",
      "label": "勾选",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          model: {
            value: (scope.row.Select),
            callback: function($$v) {
              _vm.$set(scope.row, "Select", $$v)
            },
            expression: "scope.row.Select"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "GroupItemName",
      "label": "项目名称",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Achievement",
      "label": "报名成绩",
      "width": "120",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          model: {
            value: (scope.row.Achievement),
            callback: function($$v) {
              _vm.$set(scope.row, "Achievement", $$v)
            },
            expression: "scope.row.Achievement"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AchievementRemake",
      "label": "报名备注",
      "min-width": "180",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          model: {
            value: (scope.row.AchievementRemake),
            callback: function($$v) {
              _vm.$set(scope.row, "AchievementRemake", $$v)
            },
            expression: "scope.row.AchievementRemake"
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('br'), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.cancelRelay($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.entryRelay($event)
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "工作人员报名",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.StaffVisible),
      callback: function($$v) {
        _vm.StaffVisible = $$v
      },
      expression: "StaffVisible"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.StaffEntry),
      expression: "StaffEntry"
    }]
  }, [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.Loading),
      expression: "Loading"
    }],
    attrs: {
      "data": _vm.StaffEntryList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "姓名",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Sex",
      "label": "性别",
      "width": "100",
      "formatter": _vm.formatSex,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Phone",
      "label": "联系号码",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "IdentityEnum",
      "label": "本队职务",
      "formatter": _vm.formatStaffType,
      "width": "240",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Remark",
      "label": "备注",
      "min-width": "180",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleStaffSelect(scope.row)
            }
          }
        }, [_vm._v("选择")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.StaffFromVisible),
      expression: "StaffFromVisible"
    }]
  }, [_c('el-form', {
    ref: "StaffFrom",
    attrs: {
      "model": _vm.SelectStaffRow,
      "label-width": "100px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "证件号码",
      "prop": "IDnumber"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.SelectStaffRow.IDnumber),
      callback: function($$v) {
        _vm.$set(_vm.SelectStaffRow, "IDnumber", $$v)
      },
      expression: "SelectStaffRow.IDnumber"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "Name"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.SelectStaffRow.Name),
      callback: function($$v) {
        _vm.$set(_vm.SelectStaffRow, "Name", $$v)
      },
      expression: "SelectStaffRow.Name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机号码",
      "prop": "Phone"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.SelectStaffRow.Phone),
      callback: function($$v) {
        _vm.$set(_vm.SelectStaffRow, "Phone", $$v)
      },
      expression: "SelectStaffRow.Phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "Sex"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.SelectStaffRow.Sex == 0 ? '女' : '男'),
      callback: function($$v) {
        _vm.$set(_vm.SelectStaffRow, "Sex==0?'女':'男'", $$v)
      },
      expression: "SelectStaffRow.Sex==0?'女':'男'"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出生日期",
      "prop": "Birthday"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.SelectStaffRow.Birthday),
      callback: function($$v) {
        _vm.$set(_vm.SelectStaffRow, "Birthday", $$v)
      },
      expression: " SelectStaffRow.Birthday"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "担任职务",
      "prop": "IdentityEnum"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.SelectStaffRow.IdentityEnum),
      callback: function($$v) {
        _vm.$set(_vm.SelectStaffRow, "IdentityEnum", $$v)
      },
      expression: "SelectStaffRow.IdentityEnum"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 0
    }
  }, [_vm._v("领队")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 1
    }
  }, [_vm._v("教练")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 2
    }
  }, [_vm._v("医生")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 3
    }
  }, [_vm._v("裁判")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": 4
    }
  }, [_vm._v("工作人员")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.SelectStaffRow.Remark),
      callback: function($$v) {
        _vm.$set(_vm.SelectStaffRow, "Remark", $$v)
      },
      expression: "SelectStaffRow.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('br'), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.staffAdd($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.entryStaff($event)
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "运动员报名",
      "close-on-click-modal": false
    },
    model: {
      value: (_vm.PlayerVisible),
      callback: function($$v) {
        _vm.PlayerVisible = $$v
      },
      expression: "PlayerVisible"
    }
  }, [_c('el-steps', {
    attrs: {
      "active": _vm.PlayerActive,
      "finish-status": "success",
      "align-center": ""
    }
  }, [_c('el-step', {
    staticStyle: {
      "width": "47%"
    },
    attrs: {
      "title": "第1步",
      "description": "选择/添加运动员"
    }
  }), _vm._v(" "), _c('el-step', {
    staticStyle: {
      "width": "47%"
    },
    attrs: {
      "title": "第2步",
      "description": "确认/修改信息"
    }
  }), _vm._v(" "), _c('el-step', {
    staticStyle: {
      "width": "10%"
    },
    attrs: {
      "title": "第3步",
      "description": "赛事报名"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.PlayerEntry),
      expression: "PlayerEntry"
    }],
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-button', {
    staticStyle: {
      "margin-top": "12px"
    },
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.selectPlayer
    }
  }, [_vm._v("选择已添加运动员")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.PlayerListEntry),
      expression: "PlayerListEntry"
    }]
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "size": "width:100%; height:100%;",
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getPlayer
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "运动员名称"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getPlayer($event)
      }
    },
    model: {
      value: (_vm.filters.EntryName),
      callback: function($$v) {
        _vm.$set(_vm.filters, "EntryName", $$v)
      },
      expression: "filters.EntryName"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.Loading),
      expression: "Loading"
    }],
    staticStyle: {
      "width": "1702px"
    },
    attrs: {
      "data": _vm.PlayerEntryList,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "Name",
      "label": "姓名",
      "width": "120",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "LicenseNumber",
      "label": "证件号",
      "width": "240",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Sex",
      "label": "性别",
      "width": "100",
      "formatter": _vm.formatSex,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Phone",
      "label": "联系号码",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Birthday",
      "label": "出生日期",
      "min-width": "180",
      "formatter": _vm.formatDate,
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "width": "80",
      "fixed": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "type": "danger",
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.handleSelect(scope.row)
            }
          }
        }, [_vm._v("选择")])]
      }
    }])
  })], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.PlayerInfo),
      expression: "PlayerInfo"
    }]
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px"
    }
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "点击查看大图",
      "placement": "left-end",
      "effect": "dark"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100px",
      "width": "100px",
      "background-image": "background-repeat: no-repeat",
      "background-position": "center center",
      "background-size": "cover"
    },
    attrs: {
      "src": _vm.editForm.ImageUrl
    },
    on: {
      "click": function($event) {
        _vm.see(_vm.editForm.ImageUrl)
      }
    }
  })])], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('el-upload', {
    attrs: {
      "http-request": _vm.upload,
      "action": ""
    }
  }, [_c('el-button', {
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_vm._v("点击上传")]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传jpg/png文件，且不超过500kb")])], 1)], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "姓名全拼",
      "prop": "FullNname"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.editForm.FullNname),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "FullNname", $$v)
      },
      expression: "editForm.FullNname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "Sex"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.editForm.Sex == 0 ? '女' : '男'),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Sex==0?'女':'男'", $$v)
      },
      expression: "editForm.Sex==0?'女':'男'"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "出生日期",
      "prop": "Birthday"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": true
    },
    model: {
      value: (_vm.editForm.Birthday),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Birthday", $$v)
      },
      expression: " editForm.Birthday"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "教练",
      "prop": "CompetitionTeamStaffId"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "placeholder": "请选择教练"
    },
    model: {
      value: (_vm.editForm.CompetitionTeamStaffId),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "CompetitionTeamStaffId", $$v)
      },
      expression: "editForm.CompetitionTeamStaffId"
    }
  }, _vm._l((_vm.coachOptions), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name,
        "value": item.Id
      }
    })
  }))], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea"
    },
    model: {
      value: (_vm.editForm.Remark),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "Remark", $$v)
      },
      expression: "editForm.Remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.selectPlayer($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.entryEditSubmit($event)
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.GroupInfo),
      expression: "GroupInfo"
    }]
  }, [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('span', {
    staticStyle: {
      "float": "left"
    }
  }, [_vm._v(_vm._s(_vm.editForm.Name) + "  " + _vm._s(_vm.editForm.Sex == 0 ? '女' : '男') + "  " + _vm._s(_vm.editForm.LicenseNumber))]), _vm._v(" "), _c('el-form', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "inline": true,
      "model": _vm.filters
    },
    nativeOn: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [_c('el-form-item', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "选择赛事分组"
    },
    on: {
      "change": _vm.selectChange
    },
    model: {
      value: (_vm.filters.GroupId),
      callback: function($$v) {
        _vm.$set(_vm.filters, "GroupId", $$v)
      },
      expression: "filters.GroupId"
    }
  }, _vm._l((_vm.GroupOptions), function(item) {
    return _c('el-option', {
      key: item.Id,
      attrs: {
        "label": item.Name + ' ' + (item.Sex == 0 ? '女子' : item.Sex == 1 ? '男子' : item.Sex == 2 ? '男子女子' : '未知') + ' (' + item.AgeMin + '-' + item.AgeMax + ')',
        "value": item.Id
      }
    })
  }))], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.Loading),
      expression: "Loading"
    }],
    staticStyle: {
      "width": "1702px"
    },
    attrs: {
      "data": _vm.GroupItemTable,
      "highlight-current-row": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "Prop": "Select",
      "label": "勾选",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          model: {
            value: (scope.row.Select),
            callback: function($$v) {
              _vm.$set(scope.row, "Select", $$v)
            },
            expression: "scope.row.Select"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "GroupItemName",
      "label": "项目名称",
      "width": "200",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Achievement",
      "label": "报名成绩",
      "width": "120",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          model: {
            value: (scope.row.Achievement),
            callback: function($$v) {
              _vm.$set(scope.row, "Achievement", $$v)
            },
            expression: "scope.row.Achievement"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "Test",
      "label": "测验",
      "width": "100",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          model: {
            value: (scope.row.Test),
            callback: function($$v) {
              _vm.$set(scope.row, "Test", $$v)
            },
            expression: "scope.row.Test"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "SpecialMark",
      "label": "特标",
      "width": "100",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          model: {
            value: (scope.row.SpecialMark),
            callback: function($$v) {
              _vm.$set(scope.row, "SpecialMark", $$v)
            },
            expression: "scope.row.SpecialMark"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "AchievementRemake",
      "label": "成绩说明",
      "min-width": "180",
      "sortable": ""
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-input', {
          model: {
            value: (scope.row.AchievementRemake),
            callback: function($$v) {
              _vm.$set(scope.row, "AchievementRemake", $$v)
            },
            expression: "scope.row.AchievementRemake"
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('br'), _vm._v(" "), _c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.selectPlayer($event)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.entryPlayer($event)
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')], 1)], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "查看大图"
    },
    model: {
      value: (_vm.seeImageVisible),
      callback: function($$v) {
        _vm.seeImageVisible = $$v
      },
      expression: "seeImageVisible"
    }
  }, [_c('img', {
    staticStyle: {
      "height": "100%",
      "width": "100%",
      "background-image": "background-repeat: no-repeat",
      "background-position": "center center",
      "background-size": "cover"
    },
    attrs: {
      "src": _vm.imgUrl
    }
  })])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a5664748"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Competition/Entry.vue
// module id = 1402
// module chunks = 1